import { AuthState } from '@okta/okta-auth-js';

import { PositionEntries } from '../../services/backend/PositionEntries';
import { useBaseApiClient } from '../useBaseApiClient';

export const usePositionEntries: () => PositionEntries<AuthState> = () => {
  return useBaseApiClient(PositionEntries);
};
